import {
  createSlice,
  Draft
} from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

export type ThemeSwitcherState = {
  darkMode: boolean
}

const initialState: ThemeSwitcherState = {
  darkMode: (window || {} as any).localStorage?.getItem('darkMode') === 'true'
}

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setDarkMode: (state: Draft<ThemeSwitcherState>, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload
      localStorage.setItem('darkMode', JSON.stringify(state.darkMode))
    }
  }
})

export const { setDarkMode } = themeSlice.actions

export const getDarkModeSelector = (state: RootState) => !!state.theme?.darkMode

export default themeSlice.reducer
